import axios from "axios";
import { API_ENDPOINT } from "../config";


export const handleLogin = async (data) => {
    const { email, password, reToken } = data
    let fd = new FormData()
    fd.append('email', email)
    fd.append('password', password)
    fd.append('reToken', reToken)
    let res = await axios({
        method: "POST",
        data: fd,
        url: `${API_ENDPOINT}login`,
        withCredentials: true,
    })
    return res
};